import React, {Component} from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import debounce from 'debounce'

class NRTFormStateManager extends Component {

    state = {
        resetCount: 0,
        validateCount: 0,
    }

    /* state como variavel da classe, previne render desnecessario */
    stateBuffer = {
        valid: true,
        dirty: false,
        values: {},
        fieldsWithError: {},

    }


    getChildContext() {
        return {
            onInputChange: this.onInputChange,
            onInputRemoved: this.onInputRemoved,
            resetCount: this.state.resetCount,
            validateCount: this.state.validateCount,
        }
    }

    validate(callback) {

        this.setState(state => ({
                validateCount: state.validateCount + 1
            }),
            () => {
                if (callback)
                    callback( )
            })
    }

    reset() {
        this.setState(state => ({
            resetCount: state.resetCount + 1
        }))
    }


    onInputChange = (name, value, dirty, valid = true) => {

        _.set(this.stateBuffer.values, name, value)
        this.stateBuffer.dirty = dirty

        if (valid)
            delete  this.stateBuffer.fieldsWithError[name]
        else
            this.stateBuffer.fieldsWithError[name] = true

        this.stateBuffer.valid = Object.keys(this.stateBuffer.fieldsWithError).length === 0

        this.notifyStateChangedDebounced()

    }

    onInputRemoved = (name) => {
        if (this.props.doUnmountInput) {
            delete this.stateBuffer.fieldsWithError[name]
            delete this.stateBuffer.values[name]

            this.stateBuffer.valid = Object.keys(this.stateBuffer.fieldsWithError).length === 0
            this.notifyStateChangedDebounced()
        }
    }

    notifyStateChangedDebounced = debounce(
        () => {
            if (this.props.debug)
                this.printDebugInfo()

            this.props.onStateChange(this.stateBuffer)
        }, 100)


    printDebugInfo = debounce(() => {
        console.log('chamando')
        const {
            dirty,
            valid,
            values,
            fieldsWithError,

        } = this.stateBuffer

        console.log(fieldsWithError, 'fieldsWithError')
        console.log(dirty, 'Dirty')
        console.log(valid, 'Valid')
        console.log(JSON.stringify(values, null, 2))
    }, 500)


    render() {
        return (
            this.props.nestedForm ?
                this.props.children : <div>{this.props.children}</div>
        )

    }
}


NRTFormStateManager.childContextTypes = {
    onInputChange: PropTypes.func,
    onInputRemoved: PropTypes.func,
    resetCount: PropTypes.number,
    validateCount: PropTypes.number,

}

NRTFormStateManager.propTypes = {
    onStateChange: PropTypes.func.isRequired,
    debug: PropTypes.bool,
    nestedForm: PropTypes.bool,
    doUnmountInput: PropTypes.bool,
}

NRTFormStateManager.defaultProps = {
    nestedForm: false,
    doUnmountInput: true,
}


export default NRTFormStateManager



// WEBPACK FOOTER //
// ./src/components/_common/_form/FormStateManager/index.js